import React from "react";
import { DESIGN } from "../data/siteData";
import ServicePage from "./ServicePage";

export default function DesignPage({ onNavigate }) {
  return (
    <ServicePage hero={DESIGN.hero} onNavigate={onNavigate}>
      <section className="section">
        <div className="capability-grid">
          {DESIGN.services.map((s, i) => (
            <div key={i} className="capability-card">
              <div className="capability-card-header">
                <h4>{s.title}</h4>
                <span className="capability-icon">{s.icon}</span>
              </div>
              <p>{s.desc}</p>
            </div>
          ))}
        </div>
      </section>
    </ServicePage>
  );
}
